module.exports = __webpack_public_path__ + "img/icon-arrow-background-btn.b98f1597.svg";